import _ from "lodash";
import { CompanyConstant, compFspRequiredFieldList } from "presentation/constant/Company/CompanyConstant";
//import { FSPCountingDroOpts } from "presentation/constant/DropDownOptions/Company/FSPCountingDroOpts";
import { useCompanyDetailVM } from "presentation/hook/Company/useCompanyDetailVM";
import { useCompanyFspVM } from "presentation/hook/Company/useCompanyFspVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";

import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { FieldType, HPHButton, HPHCheckbox, HPHInputTextarea, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const CompanyFspFormPanel = () => {
    const [companyDtlState] = useCompanyDetailTracked();
    const companyFspVM = useCompanyFspVM();
    const companyDtlVM = useCompanyDetailVM();
    const messageBarVM = useMessageBarVM();

    const COMPANY_DTL_CONST = CompanyConstant.Detail;
    const [isLoading, setIsLoading] = useState(false);
    const [isInitFormData, setIsInitFormData] = useState(true);
    const { dynamicOptions } = companyDtlState
    const { isAdd, isEditable, isEditCompDtlInfo, allFormState, isSaveClicked } = companyDtlState.viewState
    const { currentCompanyFsp } = companyDtlState.companyFspState;
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;

    useEffect(() => {
        if (companyDtlState.viewState.isShowFsp && isInitFormData) {
            setIsInitFormData(false);
            setIsLoading(true);
            Promise.allSettled([
                companyFspVM.loadDropdownOption(operatingUnit, companyDtlState),
            ]).then(data => {
                if (isAdd) {
                    companyFspVM.onInitDefaultValue(companyDtlState);
                }
                setIsLoading(false);
            }).catch(error => {
                setIsLoading(false);
            });
        }
    }, [companyFspVM, companyDtlState.isShowRightPanel, companyDtlState.viewState.isShowFsp, isAdd, companyDtlState.companyId, operatingUnit, isInitFormData, companyDtlState]);

    const handleCancelClick = useCallback(() => {
        companyDtlVM.onCancel();
    }, [companyDtlVM])

    const memoSubChgTypeOptions = useMemo(() => {
        const groupOfSubChgTypeOptions = companyDtlState.dynamicOptions.fspSubChargeTypeDropdownOptions[currentCompanyFsp.chargeType ?? ""];
        const commonSubChgTypeOptions = _.orderBy(_.uniqBy(_.flatMap(_.concat(groupOfSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        return commonSubChgTypeOptions;
    }, [companyDtlState.dynamicOptions.fspSubChargeTypeDropdownOptions, currentCompanyFsp.chargeType]);

    const handleSaveClick = useCallback(() => {
        if (currentCompanyFsp) {
            setIsLoading(true);
            let newentity = currentCompanyFsp;
            if (isAdd) {
                newentity = {
                    ...newentity,
                    companyId: companyDtlState.companyId,
                }

            }
            if (currentCompanyFsp.splitFirstDays && (currentCompanyFsp.splitFirstDays < 0 || currentCompanyFsp.splitFirstDays > 10000)) {
                messageBarVM.showError("Split First Days Input Value should be range from 0 to 10000.");
                setIsLoading(false);
                return;
            }

            const fields = [currentCompanyFsp.graceHourFrom, currentCompanyFsp.graceHourTo, currentCompanyFsp.graceMinuteFrom, currentCompanyFsp.graceMinuteTo];
            const hasSome = fields.some(f => f !== null);
            const hasAll = fields.every(f => f !== null);

            if (hasSome && !hasAll) {
                messageBarVM.showError('Grace hour and Grace minute should be input together.');
                setIsLoading(false);
                return;
            }
            if (currentCompanyFsp.graceHourFrom && currentCompanyFsp.graceHourFrom > 23) {
                messageBarVM.showError("Grace Hour Count From Input Value should be range from 0 to 23.");
                setIsLoading(false);
                return;
            }
            if (currentCompanyFsp.graceHourTo && currentCompanyFsp.graceHourTo > 23) {
                messageBarVM.showError("Grace Hour Count To Input Value should be range from 0 to 23.");
                setIsLoading(false);
                return;
            }
            if (currentCompanyFsp.graceMinuteFrom && currentCompanyFsp.graceMinuteFrom > 59) {
                messageBarVM.showError("Grace Minute Count From Input Value should be range from 0 to 59.");
                setIsLoading(false);
                return;
            }
            if (currentCompanyFsp.graceMinuteTo && currentCompanyFsp.graceMinuteTo > 59) {
                messageBarVM.showError("Grace Minute Count To Input Value should be range from 0 to 59.");
                setIsLoading(false);
                return;
            }
            if (currentCompanyFsp.firstTierFSP && currentCompanyFsp.firstTierFSP > 1000) {
                messageBarVM.showError("1st Tier FSP should be range from 0 to 10000.");
                setIsLoading(false);
                return;
            }
            if (currentCompanyFsp.secondTierFSP && currentCompanyFsp.secondTierFSP > 1000) {
                messageBarVM.showError("2nd Tier FSP should be range from 0 to 10000.");
                setIsLoading(false);
                return;
            }
            companyDtlVM.onSaveClicked();
            companyFspVM.onSave(newentity, isAdd, companyDtlState).then((data) => {
                if (data && data["saveCompanyFspFailed"]) {
                    setIsLoading(false);
                    messageBarVM.showError(data["saveCompanyFspFailed"]?.toString());
                    return;
                }

                companyDtlState.companyId && companyFspVM.initialFspTableData(companyDtlState.companyId).then(() => {
                    setIsLoading(false);
                }).catch((error) => {
                    setIsLoading(false);
                });
            }).catch(() => {
                setIsLoading(false);
                messageBarVM.showError('Save Data Failed.');
            });
        }
    }, [companyDtlState, companyDtlVM, companyFspVM, currentCompanyFsp, isAdd, messageBarVM])

    const isDisabled = useCallback(() => {
        if (!isEditCompDtlInfo || currentCompanyFsp?.status === "FINALIZED" || currentCompanyFsp?.status === "PROPOSED") return true;

        return false;
    }, [currentCompanyFsp?.status, isEditCompDtlInfo])


    const isReadOnly = useCallback(() => {
        if (!isEditCompDtlInfo || currentCompanyFsp?.status === "FINALIZED" || currentCompanyFsp?.status === "PROPOSED") return true;
        if (currentCompanyFsp?.chargeType === "HDL" && currentCompanyFsp?.subChargeType === "DLY") {
            return true;
        }
        return false;
    }, [currentCompanyFsp?.chargeType, currentCompanyFsp?.subChargeType, currentCompanyFsp?.status, isEditCompDtlInfo])

    const isShowOptional = useCallback(() => {
        if (currentCompanyFsp?.chargeType === "HDL" && currentCompanyFsp?.subChargeType === "DLY") {
            return false;
        }
        return true;
    }, [currentCompanyFsp?.chargeType, currentCompanyFsp?.subChargeType])


    // const getStartTime = (hours: number, min: number) => {
    //     const sysdate = moment();
    //     sysdate.hours(hours);
    //     sysdate.minutes(min);
    //     return sysdate
    // }

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        companyFspVM.onFieldChange(fieldName, fieldValue);
    }, [companyFspVM]);

    const handleTextAreaChange = useCallback((event: any, fieldName: string) => {
        const fieldValue = event.target.value;
        companyFspVM.onFieldChange(fieldName, fieldValue);
    }, [companyFspVM])

    /*const selectedFspCountingFromVal = useMemo(() => {
       // return FSPCountingDroOpts(operatingUnit).getFromValueByKey(currentCompanyFsp.chargeType ?? "", currentCompanyFsp.fspCountingFrom ?? "");
        const newChageType = companyFspVM.getChargeTypeForCC(currentCompanyFsp.chargeType ?? "", currentCompanyFsp.subChargeType ?? "");
        return FSPCountingDroOpts(operatingUnit).getFromValueByKey(newChageType, currentCompanyFsp.fspCountingFrom ?? "");
    }, [companyFspVM, currentCompanyFsp.chargeType, currentCompanyFsp.fspCountingFrom, currentCompanyFsp.subChargeType, operatingUnit])

    const selectedFspCountingToVal = useMemo(() => {
        const newChageType = companyFspVM.getChargeTypeForCC(currentCompanyFsp.chargeType ?? "", currentCompanyFsp.subChargeType ?? "");
        return FSPCountingDroOpts(operatingUnit).getToValueByKey(newChageType, currentCompanyFsp.fspCountingTo ?? "");
    }, [companyFspVM, currentCompanyFsp.chargeType, currentCompanyFsp.fspCountingTo, currentCompanyFsp.subChargeType, operatingUnit])*/

    const onSubChargeTypeChange = useCallback((fieldKey: string, fieldValue: any) => {
        companyFspVM.onSubChargeTypeChange(fieldKey, currentCompanyFsp.chargeType ?? "", fieldValue, operatingUnit);
    }, [companyFspVM, currentCompanyFsp.chargeType, operatingUnit])

    const onCntrMovementChange = useCallback((fieldKey: string, fieldValue: any) => {
        companyFspVM.onCntrMovementChange(fieldKey, currentCompanyFsp.chargeType ?? "", fieldValue);
    }, [companyFspVM, currentCompanyFsp.chargeType])

    const memoDirectionOptions = useMemo(() => {
        const directionKey = currentCompanyFsp.chargeType + "_" + currentCompanyFsp.subChargeType;
        const directionOptions = companyDtlState.dynamicOptions.directionDropdownOptions[directionKey];
        const tempDirectionDroOpts = companyDtlState.dynamicOptions.directionDropdownOptions[(currentCompanyFsp.chargeType + "_")]

        const newDirectionDroOpts = _.unionBy(directionOptions, tempDirectionDroOpts, "value");

        return newDirectionDroOpts;
    }, [companyDtlState.dynamicOptions.directionDropdownOptions, currentCompanyFsp.chargeType, currentCompanyFsp.subChargeType])

    const isCalcBySplitDay = useMemo(() => {
        if ("By Splitting Day" === currentCompanyFsp.fspCalculateMethod) return true;

        return false;
    }, [currentCompanyFsp.fspCalculateMethod])

    const memoEffectiveDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={isDisabled()}
                label={COMPANY_DTL_CONST.EFFECTIVE_DATE}
                width="300px"
                date={currentCompanyFsp?.effectiveDate ?? null}
                fieldName="effectiveDate"
                errorMessage={allFormState ? allFormState["effectiveDate"] : ""}
                onDateChange={companyFspVM.onFieldChange} />
        </div>
        , [COMPANY_DTL_CONST.EFFECTIVE_DATE, allFormState, companyFspVM.onFieldChange, currentCompanyFsp?.effectiveDate, isDisabled])

    const memoOperatingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.operatingTml ?? ''}
                fieldValue={currentCompanyFsp?.operatingTml ?? ''}
                fieldLabel={COMPANY_DTL_CONST.OPERATING_TML}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                options={dynamicOptions.operatingTmlDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.OPERATING_TML, allFormState, companyFspVM, currentCompanyFsp?.operatingTml, dynamicOptions.operatingTmlDropdownOptions, isDisabled])

    const memoConsortiumCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.consortiumCode ?? ''}
                fieldValue={currentCompanyFsp?.consortiumCode ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.CONSORTIUM_CODE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'consortiumCode'}
                options={dynamicOptions.consortiumCodeDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.CONSORTIUM_CODE, allFormState, companyFspVM, currentCompanyFsp?.consortiumCode, dynamicOptions.consortiumCodeDropdownOptions, isDisabled])

    const memoServiceCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.serviceCode ?? ''}
                fieldValue={currentCompanyFsp?.serviceCode ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.SERVICE_CODE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'serviceCode'}
                options={dynamicOptions.serviceCodeDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.SERVICE_CODE, allFormState, companyFspVM, currentCompanyFsp?.serviceCode, dynamicOptions.serviceCodeDropdownOptions, isDisabled])

    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["chargeType"] : ""}
                isReadOnly={isDisabled()}
                //isShowOptional={true}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp.chargeType ?? ""}
                fieldValue={currentCompanyFsp.chargeType ?? ""}
                fieldLabel={COMPANY_DTL_CONST.CHARGE_TYPE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeType'}
                options={dynamicOptions.fspChargeTypeDropdownOptions}
                isSaveClicked={isSaveClicked}
                maxLength={60}
                sort={false}
                requiredFieldList={compFspRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>

                    companyFspVM.onChargeTypeChange(fieldKey, fieldValue && fieldValue.toString(), anaInfoState.operatingUnit, fFullValue)} />
        </div>
        , [allFormState, isDisabled, currentCompanyFsp.chargeType, COMPANY_DTL_CONST.CHARGE_TYPE, dynamicOptions.fspChargeTypeDropdownOptions, isSaveClicked, companyFspVM, anaInfoState.operatingUnit])

    const memoSubChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.subChargeType ?? ''}
                fieldValue={currentCompanyFsp?.subChargeType ?? ''}
                fieldLabel={COMPANY_DTL_CONST.SUB_CHARGE_TYPE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChargeType'}
                options={memoSubChgTypeOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    onSubChargeTypeChange(fieldKey, fieldValue && fieldValue.toString())} />
        </div>
        , [COMPANY_DTL_CONST.SUB_CHARGE_TYPE, allFormState, currentCompanyFsp?.subChargeType, isDisabled, memoSubChgTypeOptions, onSubChargeTypeChange])

    const memoShipmentType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["shipmentType"] : ""}
                isReadOnly={isDisabled()}
                //isShowOptional={true}                
                isMultipleDropDown={true}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.shipmentType ?? ''}
                fieldValue={currentCompanyFsp?.shipmentType?.split(",").filter(item => item.trim() !== '') ?? ''}
                allValues={currentCompanyFsp?.shipmentType ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.SHIPMENT_TYPE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'shipmentType'}
                options={dynamicOptions.shipmentTypeDropdownOptions}
                isSaveClicked={isSaveClicked}
                maxLength={60}
                sort={false}
                requiredFieldList={compFspRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.SHIPMENT_TYPE, allFormState, companyFspVM, currentCompanyFsp?.shipmentType, dynamicOptions.shipmentTypeDropdownOptions, isDisabled, isSaveClicked])

    const memoCntrMovement = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.cntrMovement ?? ''}
                fieldValue={currentCompanyFsp?.cntrMovement ?? ''}
                fieldLabel={COMPANY_DTL_CONST.CNTR_MOVEMENT}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrMovement'}
                options={dynamicOptions.cntrMovementDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    onCntrMovementChange(fieldKey, fieldValue && fieldValue.toString())} />
        </div>
        , [COMPANY_DTL_CONST.CNTR_MOVEMENT, allFormState, currentCompanyFsp?.cntrMovement, dynamicOptions.cntrMovementDropdownOptions, isDisabled, onCntrMovementChange])

    const memoCntrStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.cntrStatus ?? ''}
                fieldValue={currentCompanyFsp?.cntrStatus ?? ''}
                fieldLabel={COMPANY_DTL_CONST.CNTR_STATUS}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrStatus'}
                options={dynamicOptions.cntrStatusDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.CNTR_STATUS, allFormState, companyFspVM, currentCompanyFsp?.cntrStatus, dynamicOptions.cntrStatusDropdownOptions, isDisabled])

    const memoOpsLine = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={true}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.owner ?? ''}
                fieldValue={currentCompanyFsp?.owner?.split(",").filter(item => item.trim() !== '') ?? ''}
                allValues={currentCompanyFsp?.owner ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.OPS_LINE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'owner'}
                options={dynamicOptions.opsLineDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.OPS_LINE, allFormState, companyFspVM, currentCompanyFsp?.owner, dynamicOptions.opsLineDropdownOptions, isDisabled])

    const memoForwarderCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={true}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.forwarderCode ?? ''}
                fieldValue={currentCompanyFsp?.forwarderCode?.split(",").filter(item => item.trim() !== '') ?? ''}
                allValues={currentCompanyFsp?.forwarderCode ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.FORWARDER_SHIPPER_CONSIGNEE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'forwarderCode'}
                options={dynamicOptions.forwardCodeDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.FORWARDER_SHIPPER_CONSIGNEE, allFormState, companyFspVM, currentCompanyFsp?.forwarderCode, dynamicOptions.forwardCodeDropdownOptions, isDisabled])

    const memoForwarderRef = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                readOnlyValue={currentCompanyFsp?.forwarderReference ?? ''}
                fieldValue={currentCompanyFsp?.forwarderReference ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.FORWARDER_REF}
                fieldType={FieldType.TEXT}
                fieldKey={'forwarderReference'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.FORWARDER_REF, allFormState, companyFspVM, currentCompanyFsp?.forwarderReference, isDisabled])

    const memoFirstTierFsp = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={COMPANY_DTL_CONST.FSP.FIRST_TIER_FSP}
                maxLength={10}
                width="300px"
                fieldName={"firstTierFSP"}
                value={currentCompanyFsp?.firstTierFSP ?? ''}
                errorMessage={allFormState ? allFormState["firstTierFSP"] : ""}
                disabled={isDisabled() || isReadOnly()}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COMPANY_DTL_CONST.FSP.FIRST_TIER_FSP, allFormState, currentCompanyFsp?.firstTierFSP, isDisabled, isReadOnly, onNumberFieldChange])

    const memoSecondTierFsp = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={COMPANY_DTL_CONST.FSP.SECOND_TIER_FSP}
                maxLength={10}
                width="300px"
                fieldName={"secondTierFSP"}
                value={currentCompanyFsp?.secondTierFSP ?? ''}
                errorMessage={allFormState ? allFormState["secondTierFSP"] : ""}
                disabled={isDisabled() || isReadOnly()}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COMPANY_DTL_CONST.FSP.SECOND_TIER_FSP, allFormState, currentCompanyFsp?.secondTierFSP, isDisabled, isReadOnly, onNumberFieldChange])

    const memoUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["fspUOM"] : ""}
                isReadOnly={isDisabled()}
                isShowOptional={false}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.fspUOM ?? ''}
                fieldValue={currentCompanyFsp?.fspUOM ?? ''}
                fieldLabel={COMPANY_DTL_CONST.UOM}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspUOM'}
                options={dynamicOptions.fspUomDropdownOptions}
                isSaveClicked={isSaveClicked}
                maxLength={60}
                sort={false}
                requiredFieldList={compFspRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.UOM, allFormState, companyFspVM, currentCompanyFsp?.fspUOM, dynamicOptions.fspUomDropdownOptions, isDisabled, isSaveClicked])

    const memoCargoCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.cargoCode ?? ''}
                fieldValue={currentCompanyFsp?.cargoCode ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.CARGO_CODE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cargoCode'}
                options={dynamicOptions.cargoCodeDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.CARGO_CODE, allFormState, companyFspVM, currentCompanyFsp?.cargoCode, dynamicOptions.cargoCodeDropdownOptions, isDisabled])

    const memoVesselCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                readOnlyValue={currentCompanyFsp?.vesselCode ?? ''}
                fieldValue={currentCompanyFsp?.vesselCode ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.VESSEL_CODE}
                fieldType={FieldType.TEXT}
                fieldKey={'vesselCode'}
                maxLength={6}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.VESSEL_CODE, allFormState, companyFspVM, currentCompanyFsp?.vesselCode, isDisabled])

    const memoVoyageCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                readOnlyValue={currentCompanyFsp?.voyageCode ?? ''}
                fieldValue={currentCompanyFsp?.voyageCode ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.VOYAGE_CODE}
                fieldType={FieldType.TEXT}
                fieldKey={'voyageCode'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.VOYAGE_CODE, allFormState, companyFspVM, currentCompanyFsp?.voyageCode, isDisabled])

    // const memoGraceHour = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
    //         <TimePicker
    //             width='300px'
    //             maxLength={2}
    //             disabled={isDisabled()}
    //             label={COMPANY_DTL_CONST.FSP.GRACE_HOUR_COUNT_FROM}
    //             type="number"
    //             minLength={2}
    //             value={getStartTime(currentCompanyFsp.graceHour ?? 0, currentCompanyFsp.graceMinute ?? 0).toDate()}
    //             onChange={(e: any) => companyFspVM.onTimePickerChange(e, 'graceHour', 'graceMinute')} />
    //     </div>
    //     , [COMPANY_DTL_CONST.FSP.GRACE_HOUR_COUNT_FROM, companyFspVM, currentCompanyFsp.graceHour, currentCompanyFsp.graceMinute, isDisabled])

    const memoCalendarAdj = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={true}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.applyCalendarAdj ?? ""}
                fieldValue={currentCompanyFsp?.applyCalendarAdj?.split(",").filter(item => item.trim() !== '') ?? ""}
                fieldLabel={COMPANY_DTL_CONST.FSP.CALENDAR_ADJ}
                allValues={currentCompanyFsp?.applyCalendarAdj ?? ""}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'applyCalendarAdj'}
                options={dynamicOptions.calendarAdjDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.CALENDAR_ADJ, allFormState, companyFspVM, currentCompanyFsp?.applyCalendarAdj, dynamicOptions.calendarAdjDropdownOptions, isDisabled])

    const memoChargeInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.chargeInd ?? ""}
                fieldValue={currentCompanyFsp?.chargeInd ?? ""}
                fieldLabel={COMPANY_DTL_CONST.FSP.CHARGE_IND}
                allValues={currentCompanyFsp?.chargeInd ?? ""}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeInd'}
                options={dynamicOptions.chargeIndDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.CHARGE_IND, allFormState, companyFspVM, currentCompanyFsp?.chargeInd, dynamicOptions.chargeIndDropdownOptions, isDisabled])

    const memoFspCountingFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["fspCountingFromVal"] : ""}
                isReadOnly={isDisabled() || isReadOnly()}
                isShowOptional={false}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={/*currentCompanyFsp?.fspCountingFrom??''*/currentCompanyFsp?.fspCountingFromVal ?? ''}
                fieldValue={/*currentCompanyFsp?.fspCountingFrom??''*/currentCompanyFsp?.fspCountingFromVal ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.FSP_COUNTING_FROM}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspCountingFromVal'}
                options={dynamicOptions.fspCountingFromDropdownOptions}
                isSaveClicked={isSaveClicked}
                maxLength={60}
                sort={false}
                requiredFieldList={compFspRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFspCountingChange(fieldKey, fieldValue && fieldValue.toString(), anaInfoState.operatingUnit, fFullValue, "fspCountingFrom")} />
        </div>
        , [allFormState, isDisabled, isReadOnly, currentCompanyFsp?.fspCountingFromVal, COMPANY_DTL_CONST.FSP.FSP_COUNTING_FROM, dynamicOptions.fspCountingFromDropdownOptions, isSaveClicked, companyFspVM, anaInfoState.operatingUnit])

    const memoFspCountingTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["fspCountingToVal"] : ""}
                isReadOnly={isDisabled() || isReadOnly()}
                isShowOptional={false}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={/*currentCompanyFsp?.fspCountingTo??''*/currentCompanyFsp?.fspCountingToVal ?? ''}
                fieldValue={/*currentCompanyFsp?.fspCountingTo??''*/currentCompanyFsp?.fspCountingToVal ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.FSP_COUNTING_TO}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspCountingToVal'}
                options={dynamicOptions.fspCountingToDropdownOptions}
                isSaveClicked={isSaveClicked}
                maxLength={60}
                sort={false}
                requiredFieldList={compFspRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFspCountingChange(fieldKey, fieldValue && fieldValue.toString(), anaInfoState.operatingUnit, fFullValue, "fspCountingTo")} />
        </div>
        , [allFormState, isDisabled, isReadOnly, currentCompanyFsp?.fspCountingToVal, COMPANY_DTL_CONST.FSP.FSP_COUNTING_TO, dynamicOptions.fspCountingToDropdownOptions, isSaveClicked, companyFspVM, anaInfoState.operatingUnit])

    const memoDirection = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["fspCountingDirection"] : ""}
                isReadOnly={isDisabled() || isReadOnly()}
                isShowOptional={false}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.fspCountingDirection ?? ''}
                fieldValue={currentCompanyFsp?.fspCountingDirection ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.DIRECTION}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspCountingDirection'}
                options={memoDirectionOptions}
                isSaveClicked={isSaveClicked}
                maxLength={60}
                sort={false}
                requiredFieldList={compFspRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.DIRECTION, allFormState, companyFspVM, currentCompanyFsp?.fspCountingDirection, isDisabled, isReadOnly, isSaveClicked, memoDirectionOptions])

    const memoRemarks = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "960px", marginBottom: "24px" }}>
            <HPHInputTextarea
                label={COMPANY_DTL_CONST.REMARKS}
                width="960px"
                rows={3}
                maxLength={1330}
                disabled={isDisabled()}
                resizable={false}
                helpIcon={false}
                optional={true}
                value={currentCompanyFsp?.remarks ?? ''}
                onChange={(e) => handleTextAreaChange(e, "remarks")} />
        </div>
        , [COMPANY_DTL_CONST.REMARKS, currentCompanyFsp?.remarks, handleTextAreaChange, isDisabled])

    const memoRejectReason = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "960px", marginBottom: "24px" }}>
            <HPHInputTextarea
                label={COMPANY_DTL_CONST.REJECT_REASON}
                width="960px"
                rows={3}
                maxLength={1330}
                disabled={true}
                resizable={false}
                helpIcon={false}
                value={currentCompanyFsp?.rejectReason ?? ''}
                onChange={() => { }} />
        </div>
        , [COMPANY_DTL_CONST.REJECT_REASON, currentCompanyFsp?.rejectReason])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={[]}
                fieldLabel={COMPANY_DTL_CONST.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                errorMessages={allFormState}
                label={''}
                checked={currentCompanyFsp?.activeInd === 'Y' ? true : false}
                disabled={!isEditCompDtlInfo}
                onChange={(e) => companyFspVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [COMPANY_DTL_CONST.ACTIVE_IND, allFormState, companyFspVM, currentCompanyFsp?.activeInd, isEditCompDtlInfo])

    const memoAgent = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={true}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.agentCode ?? ''}
                fieldValue={currentCompanyFsp?.agentCode?.split(",").filter(item => item.trim() !== '') ?? ''}
                allValues={currentCompanyFsp?.agentCode ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.AGENT}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'agentCode'}
                options={dynamicOptions.agentInfosDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.AGENT, allFormState, companyFspVM, currentCompanyFsp?.agentCode, dynamicOptions.agentInfosDropdownOptions, isDisabled])

    const memoCustomerType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.customerType ?? ''}
                fieldValue={currentCompanyFsp?.customerType ?? ''}
                allValues={currentCompanyFsp?.customerType ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.BILL_TO_COMPANY_CUSTOMER_TYPE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerType'}
                options={dynamicOptions.customerTypeDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.BILL_TO_COMPANY_CUSTOMER_TYPE, allFormState, companyFspVM, currentCompanyFsp?.customerType, dynamicOptions.customerTypeDropdownOptions, isDisabled])

    const memoGraceHourCountFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                readOnlyValue={currentCompanyFsp?.graceHourFrom?.toString() ?? ''}
                fieldValue={currentCompanyFsp?.graceHourFrom ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.GRACE_HOUR_COUNT_FROM}
                fieldType={FieldType.TEXT}
                fieldKey={'graceHourFrom'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={COMPANY_DTL_CONST.FSP.GRACE_HOUR_COUNT_FROM}
                maxLength={10}
                width="300px"
                fieldName={"graceHourFrom"}
                value={currentCompanyFsp?.graceHourFrom?.toString() ?? ''}
                errorMessage={allFormState?.graceHourFrom}
                disabled={isDisabled()}
                optional={(operatingUnit === 'AQCT' || operatingUnit === 'RSCT') ? isShowOptional() : true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COMPANY_DTL_CONST.FSP.GRACE_HOUR_COUNT_FROM, allFormState?.graceHourFrom, currentCompanyFsp?.graceHourFrom, isDisabled, isShowOptional, onNumberFieldChange, operatingUnit])

    const memoGraceMinuteCountFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                readOnlyValue={currentCompanyFsp?.graceMinuteFrom?.toString() ?? ''}
                fieldValue={currentCompanyFsp?.graceMinuteFrom ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.GRACE_MIMUTE_COUNT_FROM}
                fieldType={FieldType.TEXT}
                fieldKey={'graceMinuteFrom'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={COMPANY_DTL_CONST.FSP.GRACE_MIMUTE_COUNT_FROM}
                maxLength={10}
                width="300px"
                fieldName={"graceMinuteFrom"}
                value={currentCompanyFsp?.graceMinuteFrom?.toString() ?? ''}
                errorMessage={allFormState?.graceMinuteFrom}
                disabled={isDisabled()}
                optional={(operatingUnit === 'OICT' || operatingUnit === 'HPJZ') ? isShowOptional() : true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COMPANY_DTL_CONST.FSP.GRACE_MIMUTE_COUNT_FROM, allFormState?.graceMinuteFrom, currentCompanyFsp?.graceMinuteFrom, isDisabled, isShowOptional, onNumberFieldChange, operatingUnit])

    const memoGraceHourCountTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                readOnlyValue={currentCompanyFsp?.graceHourTo?.toString() ?? ''}
                fieldValue={currentCompanyFsp?.graceHourTo ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.GRACE_HOUR_COUNT_TO}
                fieldType={FieldType.TEXT}
                fieldKey={'graceHourTo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={COMPANY_DTL_CONST.FSP.GRACE_HOUR_COUNT_TO}
                maxLength={10}
                width="300px"
                fieldName={"graceHourTo"}
                value={currentCompanyFsp?.graceHourTo?.toString() ?? ''}
                errorMessage={allFormState?.graceHourTo}
                disabled={isDisabled()}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COMPANY_DTL_CONST.FSP.GRACE_HOUR_COUNT_TO, allFormState?.graceHourTo, currentCompanyFsp?.graceHourTo, isDisabled, onNumberFieldChange])

    const memoGraceMinuteCountTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                readOnlyValue={currentCompanyFsp?.graceMinuteTo?.toString() ?? ''}
                fieldValue={currentCompanyFsp?.graceMinuteTo ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.GRACE_MIMUTE_COUNT_TO}
                fieldType={FieldType.TEXT}
                fieldKey={'graceMinuteTo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={COMPANY_DTL_CONST.FSP.GRACE_MIMUTE_COUNT_TO}
                maxLength={10}
                width="300px"
                fieldName={"graceMinuteTo"}
                value={currentCompanyFsp?.graceMinuteTo?.toString() ?? ''}
                errorMessage={allFormState?.graceMinuteTo}
                disabled={isDisabled()}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COMPANY_DTL_CONST.FSP.GRACE_MIMUTE_COUNT_TO, allFormState?.graceMinuteTo, currentCompanyFsp?.graceMinuteTo, isDisabled, onNumberFieldChange])

    const memoFspCalculateMethod = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["fspCalculateMethod"] : ""}
                isReadOnly={isDisabled()}
                isShowOptional={false}
                isMultipleDropDown={false}
                //disableInput={true}
                isSaveClicked={isSaveClicked}
                readOnlyValue={currentCompanyFsp?.fspCalculateMethod ?? ''}
                fieldValue={currentCompanyFsp?.fspCalculateMethod ?? ''}
                allValues={currentCompanyFsp?.fspCalculateMethod ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.CALCULATION_BASIS}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspCalculateMethod'}
                options={dynamicOptions.fspCalcMethodDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.CALCULATION_BASIS, allFormState, companyFspVM, currentCompanyFsp?.fspCalculateMethod, dynamicOptions.fspCalcMethodDropdownOptions, isDisabled, isSaveClicked])

    const memoGraceExtend = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"graceExtend"}
                requiredFieldList={[]}
                fieldLabel={COMPANY_DTL_CONST.FSP.GRACE_EXTEND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                errorMessages={allFormState}
                label={''}
                checked={currentCompanyFsp?.graceExtend === 'Y' ? true : false}
                disabled={!isEditCompDtlInfo || currentCompanyFsp.status === 'FINALIZED'}
                onChange={(e) => companyFspVM.onCheckboxChange(e.checked, "graceExtend")}
            />
        </div>
        , [COMPANY_DTL_CONST.FSP.GRACE_EXTEND, allFormState, companyFspVM, currentCompanyFsp?.graceExtend, currentCompanyFsp.status, isEditCompDtlInfo])

    const memoSplitFirstDays = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            {/*<NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isDisabled()}
                isShowOptional={true}
                readOnlyValue={currentCompanyFsp?.splitFirstDays?.toString() ?? ''}
                fieldValue={currentCompanyFsp?.splitFirstDays ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.SPLIT_FIRST_DAYS}
                fieldType={FieldType.TEXT}
                fieldKey={'splitFirstDays'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />*/}
            <NumberInputComponent
                label={COMPANY_DTL_CONST.FSP.SPLIT_FIRST_DAYS}
                maxLength={60}
                width="300px"
                fieldName={"splitFirstDays"}
                value={currentCompanyFsp?.splitFirstDays ?? ''}
                errorMessage={allFormState?.splitFirstDays}
                disabled={isDisabled() || !isCalcBySplitDay}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COMPANY_DTL_CONST.FSP.SPLIT_FIRST_DAYS, allFormState?.splitFirstDays, currentCompanyFsp?.splitFirstDays, isCalcBySplitDay, isDisabled, onNumberFieldChange])

    const memoSplitFirstDaysTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["splitFirstDaysTo"] : ""}
                isReadOnly={isDisabled() || !isCalcBySplitDay}
                isShowOptional={isDisabled() || !isCalcBySplitDay}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.splitFirstDaysTo ?? ''}
                fieldValue={currentCompanyFsp?.splitFirstDaysTo ?? ''}
                allValues={currentCompanyFsp?.splitFirstDaysTo ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.SPLIT_FIRST_DAYS_TO}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'splitFirstDaysTo'}
                options={dynamicOptions.splitDaysToDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.SPLIT_FIRST_DAYS_TO, allFormState, companyFspVM, currentCompanyFsp?.splitFirstDaysTo, dynamicOptions.splitDaysToDropdownOptions, isCalcBySplitDay, isDisabled])

    const memoSplitRemainDaysTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["splitRemainDaysTo"] : ""}
                isReadOnly={isDisabled() || !isCalcBySplitDay}
                isShowOptional={isDisabled() || !isCalcBySplitDay}
                isMultipleDropDown={false}
                //disableInput={true}
                readOnlyValue={currentCompanyFsp?.splitRemainDaysTo ?? ''}
                fieldValue={currentCompanyFsp?.splitRemainDaysTo?.split(",").filter(item => item.trim() !== '') ?? ''}
                allValues={currentCompanyFsp?.splitRemainDaysTo ?? ''}
                fieldLabel={COMPANY_DTL_CONST.FSP.SPLIT_REMAIN_DAYS_TO}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'splitRemainDaysTo'}
                options={dynamicOptions.splitDaysToDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyFspVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.FSP.SPLIT_REMAIN_DAYS_TO, allFormState, companyFspVM, currentCompanyFsp?.splitRemainDaysTo, dynamicOptions.splitDaysToDropdownOptions, isCalcBySplitDay, isDisabled])

    return (
        <div className='side-form-content-wrapper' style={{ paddingBottom: "5px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{COMPANY_DTL_CONST.FSP.COMPANY_FSP}</SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoEffectiveDate}
                            {memoOperatingTml}
                            {memoConsortiumCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoServiceCode}
                            {memoChargeType}
                            {memoSubChargeType}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoShipmentType}
                            {memoCntrMovement}
                            {memoCntrStatus}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoOpsLine}
                            {memoForwarderRef}
                            {memoForwarderCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoFirstTierFsp}
                            {memoSecondTierFsp}
                            {memoUom}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoCargoCode}
                            {memoVesselCode}
                            {memoVoyageCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoFspCountingFrom}
                            {memoFspCountingTo}
                            {memoDirection}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {/* {memoGraceHour} */}
                            {(operatingUnit !== 'SAPT' && operatingUnit !== 'KICT') && memoChargeInd}
                            {(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && memoAgent}
                            {memoCalendarAdj}
                            {memoActiveInd}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoCustomerType}
                            {memoFspCalculateMethod}
                            {memoGraceExtend}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoGraceHourCountFrom}
                            {memoGraceHourCountTo}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoGraceMinuteCountFrom}
                            {memoGraceMinuteCountTo}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && memoSplitFirstDays}
                            {(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && memoSplitFirstDaysTo}
                            {(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && memoSplitRemainDaysTo}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoRemarks}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoRejectReason}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>

            <div className='im-charge-data-search-criteria-buttons'>
                {
                    <>
                        <HPHButton label={(!isAdd && !isEditable) ? 'Close' : 'Cancel'} size={'Small'} theme={'Secondary'} onClick={() => handleCancelClick()} />
                        {(isAdd || isEditable) && <HPHButton label={isAdd ? 'Add' : isEditable ? 'Update' : 'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />}
                    </>
                }
            </div>

        </div>
    )
}
export default memo(CompanyFspFormPanel);
